import React, { useState, useEffect } from "react";
import useHttp from "../../../hooks/use-http";
import { Spin, Select } from "antd";
import DynamicBarChart from "../../barChart";
import DynamicColumnChart from "../../columnChart";
import DynamicLineChart from "../../lineChart";
import DynamicPieChart from "../../pieChart";
import maleFarmer from "../../../assests/images/maleFarmer.avif";
import femaleFarmer from "../../../assests/images/femaleFarmer.jpg";

const { Option } = Select;

const TotalFarmers = ({ isMaximized, openMaximize }) => {
  const [loading, setLoading] = useState(true);
  const [totalFarmers, setTotalFarmers] = useState(0);
  const [male, setMale] = useState(0);
  const [female, setFemale] = useState(0);

  const [stateData, setStateData] = useState([]);
  const [selectedState, setSelectedState] = useState("all");

  const [chartType, setChartType] = useState("pie");

  const { sendRequest: getData } = useHttp();

  useEffect(() => {
    const url = `/api/allFarmersProcurement/?userId=${localStorage.getItem("id")}`;

    getData({ url }, (res) => {
      setTotalFarmers(res.totalFarmers || 0);
      setMale(res.maleCount || 0);
      setFemale(res.femaleCount || 0);

      setStateData(res.farmersPerState || []);
      setLoading(false);
    });
  }, [getData]);

  const filteredStateData =
    selectedState === "all"
      ? stateData
      : stateData.filter((s) => s.state === selectedState);

  const selectedMale =
    selectedState === "all" ? male : filteredStateData[0]?.maleCount || 0;

  const selectedFemale =
    selectedState === "all" ? female : filteredStateData[0]?.femaleCount || 0;

  if (isMaximized) {
    return (
      <div style={{ width: "100%", height: "100%", padding: "10px" }}>
        <div className="flex justify-between items-center mb-4">
          <Select
            value={selectedState}
            style={{ width: 220 }}
            onChange={(v) => setSelectedState(v)}
          >
            <Option value="all">All States</Option>
            {stateData.map((stateObj, i) => (
              <Option key={i} value={stateObj.state}>
                {stateObj.state}
              </Option>
            ))}
          </Select>

          <Select
            value={chartType}
            style={{ width: 150 }}
            onChange={(v) => setChartType(v)}
          >
            <Option value="pie">Pie Chart</Option>
            <Option value="column">Column Chart</Option>
            <Option value="bar">Bar Chart</Option>
            <Option value="line">Line Chart</Option>
          </Select>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "space-evenly",
            alignItems: "center",
            marginBottom: "20px",
            marginTop: "10px",
          }}
        >
          <div style={{ textAlign: "center" }}>
            <img
              src={maleFarmer}
              alt="male farmer"
              style={{ width: "80px", height: "80px", objectFit: "contain" }}
            />
            <div
              style={{
                fontSize: "28px",
                fontWeight: "700",
                marginTop: "5px",
                color: "#1d5c2e",
              }}
            >
              {selectedMale}
            </div>
          </div>

          <div style={{ textAlign: "center" }}>
            <img
              src={femaleFarmer}
              alt="female farmer"
              style={{ width: "80px", height: "80px", objectFit: "contain" }}
            />
            <div
              style={{
                fontSize: "28px",
                fontWeight: "700",
                marginTop: "5px",
                color: "#8b2c4b",
              }}
            >
              {selectedFemale}
            </div>
          </div>
        </div>

        {chartType === "pie" && (
          <DynamicPieChart
            data={filteredStateData}
            angleField="totalFarmers"
            colorField="state"
            isMaximized={true}
          />
        )}

        {chartType === "column" && (
          <DynamicColumnChart
            data={filteredStateData}
            xField="state"
            yField="totalFarmers"
            seriesField="state"
            xAxisTitle="State"
            yAxisTitle="Farmers"
          />
        )}

        {chartType === "bar" && (
          <DynamicBarChart
            data={filteredStateData}
            xField="state"
            yField="totalFarmers"
            seriesField="state"
            xAxisTitle="State"
            yAxisTitle="Farmers"
          />
        )}

        {chartType === "line" && (
          <DynamicLineChart
            data={filteredStateData}
            xField="state"
            yField="totalFarmers"
            seriesField="state"
            xAxisTitle="State"
            yAxisTitle="Farmers"
          />
        )}
      </div>
    );
  }

  return (
    <div
      className="rounded-2xl shadow-md"
      style={{
        background: "#f3e8d3",
        height: "200px",
        width: "100%",
        padding: "18px",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {loading ? (
        <div className="flex justify-center items-center h-full">
          <Spin />
        </div>
      ) : (
        <>
          <div style={{ marginTop: "0px", textAlign: "center" }}>
            <h1 style={{ fontSize: "42px", fontWeight: "700", color: "#3d5c26" }}>
              {totalFarmers}
            </h1>
            <p style={{ marginTop: "-10px", fontSize: "17px", color: "#3d5c26" }}>
              Total Farmers
            </p>
          </div>

          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              padding: "0 20px",
              marginTop: "5px",
              fontSize: "16px",
              fontWeight: "600",
              color: "#3d5c26",
            }}
          >
            <div>
              {male}
              <br />
              <span style={{ fontWeight: "400" }}>Male</span>
            </div>

            <div>
              {female}
              <br />
              <span style={{ fontWeight: "400" }}>Female</span>
            </div>
          </div>

          <div
            style={{
              position: "absolute",
              bottom: "8px",
              right: "18px",
              cursor: "pointer",
              fontWeight: "600",
              color: "#2d4f1d",
              fontSize: "14px",
            }}
            onClick={openMaximize}
          >
            More...
          </div>
        </>
      )}
    </div>
  );
};

export default TotalFarmers;
